export default "__VITE_ASSET__BM0j6a5g__"